import React, { useEffect, useState } from "react";
import '../../assets/images/favicon.ico';
import '../../assets/css/bootstrap.min.css';
import '../../assets/vendors/css/vendors.min.css';
import '../../assets/vendors/css/dataTables.bs5.min.css';
import '../../assets/vendors/css/daterangepicker.min.css';
import '../../assets/css/theme.min.css';
import AuthorTable from './AuthorTable'
import axios from "axios";
import BookTable from "../admin/BookTable";
import AdminLayout from "./component/AdminLayout";

const BookList = () => {


    return (
        <AdminLayout
            pageTitle="작품 관리"
            breadcrumbs={[
                { label: 'Home', link: '/admin' },
                { label: '작품 관리', active: true }
            ]}
        >

            <BookTable authorEmail={''} />


            <div className="offcanvas offcanvas-end" tabIndex={-1} id="proposalSent">
                <div className="offcanvas-header ht-80 px-4 border-bottom border-gray-5">
                    <div>
                        <h2 className="fs-16 fw-bold text-truncate-1-line">Sent Proposal</h2>
                        <small className="fs-12 text-muted">Sent proposal to your client's</small>
                    </div>
                    <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div
                    className="py-3 px-4 d-flex justify-content-between align-items-center border-bottom border-bottom-dashed border-gray-5 bg-gray-100">
                    <div>
                        <span className="fw-bold text-dark">Date:</span>
                        <span className="fs-11 fw-medium text-muted">25 MAY, 2023</span>
                    </div>
                    <div>
                        <span className="fw-bold text-dark">Proposal No:</span>
                        <span className="fs-12 fw-bold text-primary c-pointer">#NXL369852</span>
                    </div>
                </div>
                <div className="offcanvas-body">
                    <div className="form-group mb-4">
                        <label className="form-label">From: <span className="text-danger">*</span></label>
                        <input type="email" className="form-control" value="wrapcode.info@gmail.com"
                            placeholder="Clients..." readOnly={true} required />
                    </div>
                    <div className="form-group mb-4">
                        <label className="form-label">To: <span className="text-danger">*</span></label>
                        <input className="form-control" name="tomailcontent" value="wrapcode.info@gmail.com"
                            placeholder="To..." required />
                    </div>
                    <div className="form-group mb-4">
                        <label className="form-label">Subject: <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" placeholder="Subject..." required />
                    </div>
                    <div className="form-group mb-4">
                        <label className="form-label">URL: </label>
                        <input type="url" className="form-control" placeholder="URL..." />
                    </div>
                    <div className="form-group">
                        <label className="form-label">Messages:</label>
                        <div data-editor-target="editor" className="ht-200"></div>
                    </div>
                </div>
                <div className="px-4 gap-2 d-flex align-items-center ht-80 border border-end-0 border-gray-2">
                    <a href="javascript:void(0);" className="btn btn-primary w-50" data-alert-target="#alertMessage">Sent
                        Proposal</a>
                    <a href="javascript:void(0);" className="btn btn-danger w-50" data-bs-dismiss="offcanvas">Cancel</a>
                </div>
            </div>


        </AdminLayout>
    )

}

export default BookList;
